import SpEditor from '@/features/screenplay/components/editor/SpEditor'
import { SidebarTrigger } from '@/shared/components/ui/sidebar'
import { useRef } from 'react'

import SpToolbar from './editor/SpToolBar'
import { KEYS } from '@/components/custom/editor/stringKeys/StringKeys'

export const SpContent = () => {
    const bottomRef = useRef<HTMLDivElement | null>(null)
    return (
        <div>
            <header className="bg-background sticky top-0 flex items-center h-14 z-50 px-3">
                {/* Left-aligned SidebarTrigger */}
                <div className="z-10">
                    <SidebarTrigger />
                </div>

                <div className="absolute left-1/2 transform -translate-x-1/2">
                    <SpToolbar />
                </div>
            </header>

            <div
                className="flex flex-1 flex-col gap-4 p-4 bg-primary"
                id={KEYS.SP_EDITOR_CONTAINER}
            >
                <div className="mx-auto w-full max-w-3xl mt-15 mb-[400px]">
                    <SpEditor />
                    <div ref={bottomRef} />
                </div>
            </div>
        </div>
    )
}

export default SpContent
